import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmRemoveComponent } from '../../ui-ndms/components/modals/confirm-remove/confirm-remove.component';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NdmsConfirmRemoveService {

  public removeModal: BsModalRef;

  constructor(
    private _modalService: BsModalService
  ) { }

  remove(objectToRemove: string, callback, isMouse?:boolean) {
    let activeElement = document.activeElement;

    this.removeModal = this._modalService.show(ConfirmRemoveComponent, { ignoreBackdropClick: true });
    this.removeModal.content.objectToRemove = objectToRemove || "this item";

    this.removeModal.onHide.pipe(first()).subscribe(() => {
      //This will run regardless of modal result, but if result was yes then the callback will override it
      if (activeElement && activeElement instanceof HTMLElement) {
        activeElement.focus();
        if (isMouse) activeElement.blur();
      }
    });
    this.removeModal.content.complete.subscribe(result => {
      this.removeModal.hide();
      if (result === "yes")
        callback();
    })
  }
}
